import React, { useEffect, useState } from "react";
import Table from "../Table/Table";
import Table_Buttons from "../Table_Button/Table_button";
import { toast } from "react-toastify";
import { API } from "../../Redux/actions/API";
import Navbar from "../Navbar/Navbar";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import Spinner from "../Spinner/Spinner";

export default function ActivationNXCHistory() {
  const { userId, jwt_token } = useSelector((state) => state.Auth);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  // let user = "";

  const [isLoading, setisLoading] = useState(false);
  const [leftreferralApi, setleftreferralApi] = useState([]);
  const [currentPage, setcurrentPage] = useState(1);
  const [listPerpage, setlistPerpage] = useState(10);
  const [search, setSearch] = useState("");
  const [sidsearch, setSidSearch] = useState("");
  const [TotalAmount, setTotalAmount] = useState("");

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const referral_API = async () => {
    setisLoading(true);
    try {
      let responceRight = await API?.post(
        "/ActivationHistory_Admin",
        {
          loginid: userId,
          uid: search,
          type: "9",
          fdate: fromDate,
          tdate: toDate,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        },
      );
      console.log("activehis-->", responceRight);

      responceRight = responceRight.data.data[0];

      setleftreferralApi([]);
      let arrayLeft = [];
      let Amount = 0;
      responceRight.forEach((item, index) => {
        arrayLeft.push({
          sr: index + 1,
          user_id: `${item?.uid} `,
          sid: `${item?.sid} `,
          wallet: item?.wallet,
          f_name: `${item?.f_name} `,
          Amount: item?.Amount,
          Token: item?.tokenvalue,
          AdminRemark: item.remark,
          // tokenvalue: `${item?.tokenvalue}`,
          // BNBvalue: `${item?.BNBvalue}`,
          referby: item?.referby,
          remark: `${item?.remark} `,
          txnid: `${item?.txnid}`,
          dd: item?.dd,
          TokenType: item?.TokenType,
        });
        Amount = Amount + item?.Amount;
        setTotalAmount(Amount);
        setleftreferralApi(arrayLeft);
      });
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    } finally {
      setisLoading(false);
    }
  };

  useEffect(() => {
    referral_API();
  }, []);

  const referral_API_Export = async () => {
    try {
      let responceRight = await API?.post(
        "/ActivationHistory_Admin",
        {
          loginid: userId,
          uid: search,
          type: "9",
          fdate: fromDate,
          tdate: toDate,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        },
      );
      console.log("memberlist-->", responceRight.data.data);
      responceRight = responceRight.data.data[0];
      let arrayLeft = [];
      responceRight.forEach((item, index) => {
        arrayLeft.push({
          Sr: index + 1,
          UserId: `${item?.uid} `,
          SponserId: `${item?.sid} `,
          WalletAddress: item?.wallet,
          UsdAmount: item?.Amount,
          Token: item?.tokenvalue,
          Paytype: item.Paytype,
          ReferBy: item?.referby,
          Type: `${item?.remark} `,
          Txn: `${item?.txnid}`,
          Date: item?.dd,
        });
      });

      const fileName = "ActivationNXCRecord";
      const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const fileExtension = ".xlsx";
      const ws = XLSX.utils.json_to_sheet(arrayLeft);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = XLSX.write(wb, {
        bookType: "xlsx",
        type: "array",
      });
      const data = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(data, fileName + fileExtension);
    } catch (e) {
      console.log("Error While calling Myteam API", e);
    }
  };

  const indexOfLastPost = currentPage * listPerpage;
  const indexOfFirstPage = indexOfLastPost - listPerpage;
  const currentPostleft = leftreferralApi.slice(
    indexOfFirstPage,
    indexOfLastPost,
  );

  const getTxnUrl = (hash) => {
    if (!hash) return "#";
    return `https://bscscan.com/tx/${hash}`;
  };

  var [my_team, set_my_team] = new useState({
    cols: [
      // Amount USD	Token	Activated By	Remark	Txn	Activation Date

      { Header: "S.No.", accessor: "sr" },
      { Header: "User Id", accessor: "user_id" },
      { Header: "Sponsor Id", accessor: "sid" },
      { Header: "wallet Address", accessor: "wallet" },
      { Header: "Amount", accessor: "Amount" },
      { Header: "Token", accessor: "Token" },
      // { Header: "BNB", accessor: "BNBvalue" },
      { Header: "Activated By", accessor: "referby" },
      { Header: "Remark", accessor: "AdminRemark" },
      {
        Header: "Txn",
        accessor: "txnid",
        Cell: ({ value }) => {
          if (!value) return "-";

          return (
            <a
              href={getTxnUrl(value)}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "#007bff",
                cursor: "pointer",
                textDecoration: "none",
                fontWeight: "500",
              }}
              title={value}
            >
              View Hash
            </a>
          );
        },
      },
      { Header: "TokenType", accessor: "TokenType" },
      { Header: "Activation Date", accessor: "dd" },
    ],
  });

  return (
    <div>
      <Navbar />
      {userId === "1" ? (
        <div class="content-page">
          <div class="content">
            <div class="row">
              <div class="col-md-12">
                <div class="panel panel-primary">
                  <div class="panel-heading">
                    <h4 class="panel-title">Activation/Upgrade FWT History</h4>
                  </div>
                  <div class="panel-body">
                    <div class="row">
                      <div class="col-lg-2 col-xl-2 col-md-3">
                        <label>User Id</label>
                        <br />
                        <input
                          class="form-control in-ip-1"
                          id="uid"
                          onChange={(e) => setSearch(e.target.value)}
                          name="uid"
                          placeholder="Search By User Id or Name or Email"
                          type="text"
                          value={search}
                        />
                      </div>
                      {/* <div class="col-lg-2 col-xl-2 col-md-3">
                      <label>Sponsor Id</label>
                      <br />
                      <input
                        class="form-control in-ip-1"
                        id="sid"
                        onChange={(e) => setSidSearch(e.target.value)}
                        name="Sid"
                        placeholder="Search By Sponsor Id"
                        type="text"
                        value={sidsearch}
                      />
                    </div> */}

                      {/* <div class="col-lg-2 col-xl-2 col-md-3">
                      <label>Actvation From</label>
                      <br />
                      <input
                        class="form-control in-ip-1"
                        onChange={(e) => setFromDate(e.target.value)}
                        value={fromDate}
                        id="todate"
                        name="todate"
                        type="date"
                      />
                    </div>
                    <div class="col-lg-2 col-xl-2 col-md-3">
                      <label>Actvation To</label>
                      <br />
                      <input
                        class="form-control in-ip-1"
                        value={toDate}
                        onChange={(e) => setToDate(e.target.value)}
                        id="fdate"
                        name="fdate"
                        type="date"
                      />
                    </div> */}

                      <div class="col-lg-2 col-xl-2 col-md-3">
                        <br />
                        <input
                          type="reset"
                          id="btnsearch"
                          formmethod="get"
                          onClick={() => referral_API()}
                          class="btn btn-lg btn-primary"
                          value="Search"
                        />
                      </div>
                      <div class="col-lg-2 col-xl-2 col-md-3">
                        <br />
                        <input
                          type="reset"
                          id="btnsearch"
                          formmethod="get"
                          onClick={() => referral_API_Export()}
                          class="btn btn-lg btn-primary"
                          value="Export to Excel"
                        />
                      </div>
                    </div>
                    <div class="row">
                      <h4>
                        <span>Total Amount: {TotalAmount}</span>
                      </h4>

                      {isLoading ? (
                        <Spinner />
                      ) : (
                        <div className="col-md-12">
                          <Table
                            data={currentPostleft}
                            columns={my_team.cols}
                          />

                          <Table_Buttons
                            indexOfFirstPage={indexOfFirstPage}
                            indexOfLastPost={indexOfLastPost}
                            setcurrentPage={setcurrentPage}
                            currentPage={currentPage}
                            totalData={leftreferralApi.length}
                            listPerpage={listPerpage}
                            handleRowsPerPageChange={setlistPerpage}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <>
          <div class="content-page">
            <div class="content">
              <div class="row">
                <div class="col-md-12">
                  <div class="panel panel-primary">
                    <div class="panel-heading">
                      <h4 class="panel-title">Activation User History</h4>
                    </div>
                    <div className="text-center mt-5">
                      <h3>You are not authorized to access this page.</h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
